// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2841) return "three.css";
	// return url for filenames based on template
	return "" + chunkId + "_" + __webpack_require__.h().slice(0, 6) + ".css";
};